import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash'; // TODO: refactor the chain method in mapStateToProps as to not import all of lodash
import { ButtonV2 } from '@zola/zola-ui';


function DeleteEventModal({ event, numRsvpResponses, onDeleteEvent, hideModalFn }) {
  // TODO: Add Seating Chart information here as the deletion is prevented for them as well.
  return (
    <div id="delete-event-modal">
      <div className="modal-header">
        <h3>Wait a sec!</h3>
      </div>
      <div className="modal-body">
        <p className="modal-copy">
          Are you sure you want to delete <strong>{event.name}</strong>? If you do, the event will be removed from your website and guests will no longer be able to RSVP online.
        </p>
        <p className="warning-copy">
          Any event info, RSVPs, meal preferences, and all other questions, will be DELETED.
        </p>
        {numRsvpResponses > 0 && (
          <p className="warning-copy">
            {numRsvpResponses} {numRsvpResponses > 1 ? 'guests\'' : 'guest\'s'} RSVPs will be lost.
          </p>
        )}
        <div className="delete-modal-actions">
          <ButtonV2 variant="secondary" className="margin-right" onClick={() => onDeleteEvent()}>
            Yes, Delete
          </ButtonV2>
          <ButtonV2 onClick={hideModalFn}>
            Cancel
          </ButtonV2>
        </div>
      </div>
    </div>
  );
}

DeleteEventModal.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }),
  onDeleteEvent: PropTypes.func,
  hideModalFn: PropTypes.func,
  numRsvpResponses: PropTypes.number
};

const mapStateToProps = (state, ownProps) => {
  const { event } = ownProps;
  const guestGroups = state.guestList.guests.orderedIds.map(id => state.guestList.guests.byId[id]);
  const eventInvitationsWithResponse = _.chain(guestGroups)
    .flatMap(guestGroup => guestGroup.guests)
    .flatMap(guest => guest.event_invitations)
    .filter(eventInvitation => eventInvitation.event_id === event.id && eventInvitation.rsvp_at !== null)
    .value();
  return {
    numRsvpResponses: eventInvitationsWithResponse.length
  };
};


export default connect(
  mapStateToProps
)(DeleteEventModal);



// WEBPACK FOOTER //
// ./src/components/manage/events/components/DeleteEventModal.jsx